module.exports = __webpack_public_path__ + "img/logo2.4b94bdc9.png";